import { ChatEmojiService } from '@agent/agent-interface/contact-view/chat/services/chat-emoji.service';
import { ChatMessageUtilService } from '@agent/agent-interface/contact-view/chat/services/chat-message-util.service';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { HttpService, ProfileFacade, UntilDestroy, untilDestroyed } from '@contact/upgrade';

import { ChatMessage } from '../../model/chat-message';
import { ChatModel } from '../../model/chat-model';

@UntilDestroy()
@Component({
  selector: 'chat-message-hover',
  templateUrl: 'chat-message-hover.component.html',
  styleUrls: ['./chat-message-hover.component.scss'],
})
export class ChatMessageHover implements OnInit {
  @Input()
  public chat: ChatModel;

  @ViewChild('goToLastMessage')
  private _chatElement: ElementRef;

  private _countChatMessages: number = 0;
  private _lastContentChatMessage: string = '';
  csrId: string;

  constructor(
    private readonly chatMessageUtilService: ChatMessageUtilService,
    private readonly profileFacade: ProfileFacade,
    private readonly emojiService: ChatEmojiService,
    private readonly http: HttpService,
    private readonly domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.profileFacade.id$.pipe(untilDestroyed(this)).subscribe(id => (this.csrId = id));
  }

  getMessageContent(chatMessage: ChatMessage): string {
    let text = this.chatMessageUtilService.processContent(chatMessage.content);
    this.fetchBotImageIfNeeded(chatMessage);
    return this.emojiService.emojify(text);
  }

  private fetchBotImageIfNeeded(chatMessage: ChatMessage) {
    const hasUrl =
      chatMessage &&
      chatMessage.chatbotExchangeMessage &&
      chatMessage.chatbotExchangeMessage.attachment &&
      chatMessage.chatbotExchangeMessage.attachment.type === 'image' &&
      !chatMessage.chatbotExchangeMessage.imageUrl &&
      chatMessage.chatbotExchangeMessage.imageUrl !== '';
    if (hasUrl) {
      this.http
        .withHeaders({
          'Content-Type': 'text/plain; charset=UTF-8',
          Accept: 'text/plain',
        })
        .get(chatMessage.chatbotExchangeMessage!.attachment.url, { responseType: 'text' })
        .subscribe(res => {
          chatMessage.chatbotExchangeMessage!.imageUrl = res as string;
        });
      chatMessage.chatbotExchangeMessage!.imageUrl = '';
    }
  }

  scrollToBottom(chat: ChatModel) {
    if (this._chatElement && chat) {
      const messages = chat.messages;
      if (this._countChatMessages !== chat.messages.length || this._lastContentChatMessage !== messages[messages.length - 1].content) {
        this._chatElement.nativeElement.scrollTop = this._chatElement.nativeElement.scrollHeight;
        this._countChatMessages = chat.messages.length;
        this._lastContentChatMessage = messages[messages.length - 1].content;
      }
    }
  }

  scrollMessageToBottom() {
    const elements = document.querySelectorAll('.chat-message-content .contentMsgChat');
    if (elements) {
      const lastEl = elements[elements.length - 1];
      if (lastEl) {
        if (lastEl.clientHeight < lastEl.scrollHeight) {
          lastEl.scrollTop = lastEl.scrollHeight;
        }
      }
    }
  }

  getUrl(text: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(this.chatMessageUtilService.processUrl(text));
  }
}
